import { animate, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { IUser } from '@interfaces/IUser';
import { unfoldingAnimation } from '@myAnimations/animations';
import { IAppState } from '@myStore/app.state';
import { selectIsAuth } from '@myStore/auth/auth.selector';
import { selectProfile } from '@myStore/profile-view/profile-view.selector';
import { InitTheme } from '@myStore/theme/theme.actions';
import { selectTheme } from '@myStore/theme/theme.selector';
import { select, Store } from '@ngrx/store';
import { AuthService } from '@services/auth/auth.service';
import { FormDialogComponent } from '@shared/components/UI/form-dialog/form-dialog.component';
import { Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { FreeTimeGraphFormComponent } from './esdp/free-time-graph-form/free-time-graph-form.component';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  animations: [
    unfoldingAnimation(),
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 })),
      ]),
      transition('* => void', [animate(500, style({ opacity: 0 }))]),
    ]),
  ],
})
export class AppComponent implements OnInit, OnDestroy {
  public title = 'Attractor School CRM';
  public isAuth = false;
  public user$: IUser | null = null;
  private authSub?: Subscription;
  public showCat = false;
  public theme = 'light';
  public techWorkPage = false;
  constructor(
    private _store: Store<IAppState>,
    private _authService: AuthService,
    private router: Router,
    private titleService: Title,
    private _dialog: MatDialog,
    private overlayContainer: OverlayContainer
  ) {}
  ngOnInit(): void {
    this.authSub = this._store.pipe(select(selectIsAuth)).subscribe(auth => {
      this.isAuth = auth;
    });

    this._store.pipe(select(selectProfile)).subscribe(user => {
      if (user) {
        this.user$ = user;
      }
    });

    this._store.dispatch(new InitTheme());
    this._store.pipe(select(selectTheme)).subscribe(theme => {
      if (theme === 'cat') {
        this.showCat = true;
        setTimeout(() => {
          this.showCat = false;
        }, 1000);
      }
      this.theme = theme;
      const container = this.overlayContainer.getContainerElement().classList;
      container.remove('dark-theme', 'light-theme');
      container.add(`${theme}-theme`);
      document.body.classList.remove('light-theme', 'dark-theme');
      document.body.classList.add(`${theme}-theme`);
    });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route: ActivatedRoute = this.router.routerState.root;
          let routeTitle = '';
          while (route.firstChild) {
            route = route.firstChild;
          }
          if (route.snapshot.data['title']) {
            routeTitle = route.snapshot.data['title'];
          }
          return routeTitle;
        })
      )
      .subscribe((title: string) => {
        if (this.isAuth && this.user$) {
          if ('free_time_form' in this.user$) {
            if (
              this.user$.free_time_form?.is_remind_later === false &&
              !this.user$.free_time_form.time_ranges
            )
              this._dialog.open(FormDialogComponent, {
                width: '450px',
                data: {
                  title: 'График занятости для ESDP',
                  content: FreeTimeGraphFormComponent,
                  disableClose: true,
                  student: this.user$,
                },
              });
          }
        }

        if (title) {
          this.titleService.setTitle(title);
        } else {
          this.titleService.setTitle('AttractorCrm');
        }
      });
  }

  ngOnDestroy() {
    this.authSub?.unsubscribe();
  }
}
